/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { GetPaymentRequestEvidences200ResponseInnerErrors } from './get-payment-request-evidences200-response-inner-errors';
// May contain unused imports in some cases
// @ts-ignore
import { GetPaymentRequestEvidences200ResponseInnerFile } from './get-payment-request-evidences200-response-inner-file';
// May contain unused imports in some cases
// @ts-ignore
import { GetPaymentRequestEvidences200ResponseInnerInvoiceIssuer } from './get-payment-request-evidences200-response-inner-invoice-issuer';
// May contain unused imports in some cases
// @ts-ignore
import { GetPaymentRequestEvidences200ResponseInnerUpdatedBy } from './get-payment-request-evidences200-response-inner-updated-by';
// May contain unused imports in some cases
// @ts-ignore
import { GetPaymentRequestEvidences200ResponseInnerUploadedBy } from './get-payment-request-evidences200-response-inner-uploaded-by';
// May contain unused imports in some cases
// @ts-ignore
import { GetPaymentRequestEvidences200ResponseInnerWarnings } from './get-payment-request-evidences200-response-inner-warnings';

/**
 * 
 * @export
 * @interface GetPaymentRequestEvidences200ResponseInner
 */
export interface GetPaymentRequestEvidences200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidences200ResponseInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidences200ResponseInner
     */
    'userAccountId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidences200ResponseInner
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidences200ResponseInner
     */
    'paymentType': GetPaymentRequestEvidences200ResponseInnerPaymentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidences200ResponseInner
     */
    'electronicMethod': GetPaymentRequestEvidences200ResponseInnerElectronicMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidences200ResponseInner
     */
    'documentSize': GetPaymentRequestEvidences200ResponseInnerDocumentSizeEnum;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentRequestEvidences200ResponseInner
     */
    'detectedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentRequestEvidences200ResponseInner
     */
    'calculatedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentRequestEvidences200ResponseInner
     */
    'colorGradation': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentRequestEvidences200ResponseInner
     */
    'verticalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentRequestEvidences200ResponseInner
     */
    'horizontalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentRequestEvidences200ResponseInner
     */
    'heightMillis': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentRequestEvidences200ResponseInner
     */
    'widthMillis': number | null;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidences200ResponseInner
     */
    'legalValidity': GetPaymentRequestEvidences200ResponseInnerLegalValidityEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidences200ResponseInner
     */
    'note': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetPaymentRequestEvidences200ResponseInner
     */
    'irrelevantToLedger': boolean;
    /**
     * 
     * @type {GetPaymentRequestEvidences200ResponseInnerFile}
     * @memberof GetPaymentRequestEvidences200ResponseInner
     */
    'file': GetPaymentRequestEvidences200ResponseInnerFile;
    /**
     * 
     * @type {GetPaymentRequestEvidences200ResponseInnerInvoiceIssuer}
     * @memberof GetPaymentRequestEvidences200ResponseInner
     */
    'invoiceIssuer': GetPaymentRequestEvidences200ResponseInnerInvoiceIssuer | null;
    /**
     * 
     * @type {GetPaymentRequestEvidences200ResponseInnerErrors}
     * @memberof GetPaymentRequestEvidences200ResponseInner
     */
    'errors': GetPaymentRequestEvidences200ResponseInnerErrors;
    /**
     * 
     * @type {GetPaymentRequestEvidences200ResponseInnerWarnings}
     * @memberof GetPaymentRequestEvidences200ResponseInner
     */
    'warnings': GetPaymentRequestEvidences200ResponseInnerWarnings;
    /**
     * 
     * @type {GetPaymentRequestEvidences200ResponseInnerUpdatedBy}
     * @memberof GetPaymentRequestEvidences200ResponseInner
     */
    'updatedBy': GetPaymentRequestEvidences200ResponseInnerUpdatedBy;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidences200ResponseInner
     */
    'updatedAt': string;
    /**
     * 
     * @type {GetPaymentRequestEvidences200ResponseInnerUploadedBy}
     * @memberof GetPaymentRequestEvidences200ResponseInner
     */
    'uploadedBy': GetPaymentRequestEvidences200ResponseInnerUploadedBy;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidences200ResponseInner
     */
    'uploadedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetPaymentRequestEvidences200ResponseInner
     */
    'needsMigration'?: boolean;
}

export const GetPaymentRequestEvidences200ResponseInnerPaymentTypeEnum = {
    cardTransaction: 'CARD_TRANSACTION',
    paymentRequest: 'PAYMENT_REQUEST'
} as const;

export type GetPaymentRequestEvidences200ResponseInnerPaymentTypeEnum = typeof GetPaymentRequestEvidences200ResponseInnerPaymentTypeEnum[keyof typeof GetPaymentRequestEvidences200ResponseInnerPaymentTypeEnum];
export const GetPaymentRequestEvidences200ResponseInnerElectronicMethodEnum = {
    fullElectronic: 'FULL_ELECTRONIC',
    originallyPaper: 'ORIGINALLY_PAPER',
    unknown: 'UNKNOWN'
} as const;

export type GetPaymentRequestEvidences200ResponseInnerElectronicMethodEnum = typeof GetPaymentRequestEvidences200ResponseInnerElectronicMethodEnum[keyof typeof GetPaymentRequestEvidences200ResponseInnerElectronicMethodEnum];
export const GetPaymentRequestEvidences200ResponseInnerDocumentSizeEnum = {
    overA4: 'OVER_A4',
    a4OrSmaller: 'A4_OR_SMALLER',
    unknown: 'UNKNOWN'
} as const;

export type GetPaymentRequestEvidences200ResponseInnerDocumentSizeEnum = typeof GetPaymentRequestEvidences200ResponseInnerDocumentSizeEnum[keyof typeof GetPaymentRequestEvidences200ResponseInnerDocumentSizeEnum];
export const GetPaymentRequestEvidences200ResponseInnerLegalValidityEnum = {
    valid: 'VALID',
    invalid: 'INVALID',
    inputRequired: 'INPUT_REQUIRED',
    outOfTarget: 'OUT_OF_TARGET'
} as const;

export type GetPaymentRequestEvidences200ResponseInnerLegalValidityEnum = typeof GetPaymentRequestEvidences200ResponseInnerLegalValidityEnum[keyof typeof GetPaymentRequestEvidences200ResponseInnerLegalValidityEnum];


